<template>
  <div class="main-container">
    <!-- モーダル START -->
    <b-modal width="680px" :active.sync="isModal">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title title">
            画像を選択
          </p>
        </header>
        <div class="card-content parent-box">
          <div class="box-request">
            画像を下記から選ぶことができます（<a href="https://unsplash.com/">Unsplash</a>）
            <div style="width: 100%; display: flex; justify-content: flex-start; flex-wrap: wrap;">
              <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('job')">仕事1</button>
              <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('work')">仕事2</button>
              <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('meeting')">仕事3</button>
              <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('care')">介護・福祉・リハビリ1</button>
              <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('health')">介護・福祉・リハビリ2</button>
              <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('elderly care')">介護・福祉・リハビリ3</button>
              <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('nurse')">医療</button>
              <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('sales')">営業</button>
              <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('shop')">販売</button>
              <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('education')">教育</button>
              <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('designer')">デザイン</button>
              <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('hotel')">旅行・ホテル</button>
              <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('real estate')">不動産</button>
              <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('finance')">金融</button>
              <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('transportation')">運輸・輸送</button>
              <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('programming')">IT・Web</button>
              <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('engineer')">エンジニア</button>
            </div>
            <hr>
            <ul class="horizontal-image disp-scroll">
              <li v-for="photo in photos" :key="photo.id">
                <img @click="saveImageAPI(photo)" class="image-list" height="300" width="300" :src="photo.urls.thumb" alt="img"/>
              </li>
            </ul>
            <hr>
            <b-field position="is-centered" style="text-align: center !important;">
              <div class="upload-form">
                <a class="upload-style">
                  <label for="file_upload" class="upload-style">
                    <a class="button is-primary"
                    @click="openSelectModal">
                      <span class="mdi mdi-image" style="margin-right: 10px;"></span>メディア倉庫から画像を選択する
                    </a>
                    <!-- <input type="file" id="file_upload" @change="onFileChange"> -->
                    <ModalSelectMedia @updated="selectImage"></ModalSelectMedia>
                  </label>
                </a>
              </div>
            </b-field>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- モーダル END -->
    <div class="header-image" :style="{background: getImageURL(selectContent), 'background-size': 'cover'}">
      <div class="cover-filter">
        <h1 class="main-title">
          <input class="edit-input font-main" placeholder="タイトルを入力" v-model="selectContent.title">
        </h1>
        <a class="background-img-button" @click="searchPhotos('job');isModal=true" v-if="!isMobile">
          <span class="mdi mdi-plus" style="margin-right: 10px;"></span>背景を変更
        </a>
      </div>
    </div>
    <div class="box-table" v-for="(c, idx) in selectContent.content.list" :key="idx">
      <div class="header">
        <h2 class="title-group" :style="{'background': c['header_bg_color'], 'border-left': 'solid 8px'}">
          <input class="title-group -input" type="text" placeholder="ここにサブタイトルを入力" v-model="c['header']" :style="{'color': c['header_fr_color']}" >
          <button class="tooltip button color-btn" style="float: right;" @click="isColorMenu.splice(idx, 1, !isColorMenu[idx])">
            <p class="mdi mdi-palette" v-if="!isColorMenu[idx]"></p>
            <p class="mdi mdi-close"   v-if="isColorMenu[idx]" ></p>
            <div class="description">{{settingMessage}}</div>
          </button>
          <div class="color-list" v-if="isColorMenu[idx]">
            <p style="padding: 4px; width: 100%; font-size: small; color: #333;">背景色</p>
            <div @click="selectColor(c.code, idx, false)" class="color-p" v-for="(c, i) in colorList" :key="i" :style="{'background': c.code}"></div>
            <input style="width: 100%; height: 25px; margin: 4px;" type="color" v-model="c['header_bg_color']"/>
            <p style="padding: 4px; width: 100%; font-size: small; color: #333;">文字色</p>
            <div @click="selectColor('#111111', idx, true)" class="color-p" :style="{'background': '#111111'}"></div>
            <div @click="selectColor('#F8F8F8', idx, true)" class="color-p" :style="{'background': '#F8F8F8'}"></div>
          </div>
        </h2>
      </div>
      <div class="body">
        <quill-editor class="editor" style="height: 300px;" v-model="c['body']" ref="quillEditor" :options="options"></quill-editor>
      </div>

      <div class="del-btn-wrapper">
        <button class="del-btn button is-small" @click="deleteContent(idx)">削除</button>
      </div>
    </div>
    <button @click="addContent({
      header          : '',
      body            : '',
      header_fr_color : '#111111',
      header_bg_color : '#FFBBCC',
      body_fr_color   : '#111111',
      body_bg_color   : '#FFBBCC',
    })" class="button is-primary is-fullwidth" style="margin-top: 8px;">項目を追加する</button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import color from '@/assets/json/master/color.json'
import ModalSelectMedia from '@/components/ui/ModalSelectMedia'

export default {
  name: 'MainCustom',
  componentName: 'MainCustom',
  props: [
    'isMobile',
    'isView',
    'id'
  ],
  components: {
    ModalSelectMedia
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('employmentPage', ['selectContent']),
    ...mapState('mediapool', ['images'])
  },
  data () {
    return {
      isColorMenu: [],
      isModal: false,
      search: '',
      photos: [],
      colorList: color,
      options: {
        theme: 'snow',
        placeholder: '内容を入力...',
      },
      settingMessage: '背景色・\n文字色変更'
    }
  },
  mounted () {
    if (this.selectContent.content.list.length > 0 && this.isColorMenu.length == 0) {
      for (var i in this.selectContent.content.list) {
        this.isColorMenu.push(false)
      }
    }
  },
  methods: {
    openSelectModal (){
      this.$store.dispatch('mediapool/openSelectModal', {type:'image'})
    },
    selectImage (id){
      if (this.id == 'new') {
        var tmp = this.selectContent
        tmp.image = id
        tmp.is_image_original = true
        this.$store.dispatch('employmentPage/setEditContentCustom', tmp)
      } else {
        this.$store.dispatch('employmentPage/postMainContentImage', {contents_id: this.selectContent.contents_id, data: id, is_original: true})
      }
      this.isModal = false
    },
    // onFileChange (e) {
    //   console.debug('*** Start *** onFileChange')
    //   let files = e.target.files || e.dataTransfer.files
    //   // this.filename = files[0].name
    //   let reader = new FileReader()
    //   reader.onload = (e) => {
    //     if (this.id == 'new') {
    //       var temp = this.selectContent
    //       temp.image = e.target.result
    //       temp.is_image_original = true
    //       this.$store.dispatch('employmentPage/setEditContentCustom', temp)
    //     } else {
    //       this.$store.dispatch('employmentPage/postMainContentImage', {contents_id: this.selectContent.contents_id, data: e.target.result, is_original: true})
    //     }
    //   }
    //   reader.readAsDataURL(files[0])
    //   this.isModal = false
    //   console.debug('*** End *** onFileChange')
    // },
    getImageURL () {
      console.debug('*** Start *** getImageURL')
      var url = ''
      if (this.selectContent.is_image_original) {
        url = this.selectContent.image
      } else {
        if (this.selectContent.image_unsplash) {
          url = this.selectContent.image_unsplash.urls['regular'] ? this.selectContent.image_unsplash.urls.regular : this.selectContent.image_unsplash.urls.raw
        } else if (this.selectContent.image_url) {
          url = this.selectContent.image_url
        }
      }
      var defaultURL = require('@/assets/template/default_recruit.jpg')
      if (url == '') return 'url(\"' + defaultURL + '\") center center no-repeat'
      else return 'url(\"' + url + '\") center center no-repeat'
    },
    saveImageAPI (photo) {
      console.debug('*** Start *** saveImageAPI')
      if (this.id == 'new') {
        var temp = this.selectContent
        temp.image_unsplash = photo
        temp.is_image_original = false
        this.$store.dispatch('employmentPage/setEditContentCustom', temp)
      } else {
        this.$store.dispatch('employmentPage/postMainContentImage', {contents_id: this.selectContent.contents_id, data: photo, is_original: false})
      }
      this.isModal = false
      console.debug('*** End *** saveImageAPI')
    },
    searchPhotos (search) {
      console.debug('*** Start *** searchPhotos')
      console.debug('search: ' + search)
      let appid = this.$unsplash._applicationId
      let query  = search
      this.$axios.get(`https://api.unsplash.com/search/photos/?page=1&per_page=30&query=${query}&client_id=${appid}&width=1920&height=1080`)
      .then(response => {
        console.log('response: ' + JSON.stringify(response))
        this.photos = response.data.results
      })
      .catch(e => {
        console.error('error: ' + JSON.stringify(e))
      })
      console.debug('*** End *** searchPhotos')
    },
    selectColor (code, idx, isFont) {
      if (isFont) {
        this.selectContent.content.list[idx].header_fr_color = code
      } else {
        this.selectContent.content.list[idx].header_bg_color = code
      }
    },
    addContent (list) {
      this.$store.dispatch('employmentPage/addCustomContent', list)
      this.isColorMenu.push(false)
    },
    deleteContent (idx) {
      this.isColorMenu.splice(idx, 1)
      this.$store.dispatch('employmentPage/deleteCustomContent', idx)
    }
  }
}
</script>

<style lang="scss" scoped>
.main-container {
  height: 100%;
  width: 100%;
  padding: 16px;
  overflow-y: scroll;
}
.main-container::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  visibility: hidden;
}
.header-image {
  width: 100%;
  height: 200px;
  margin-bottom: 8px;
}
.cover-filter{
  display: flex;
  justify-content: center;
  align-items: center;
  height:100%;
  width: 100%;
  position: relative;
  background: rgba(0, 0, 0, 0.55) no-repeat center;
}
.main-title {
  color: white;
  font-size: 25px;
  width: 80%;
  border: dashed thin #eee;
}
.font-main {
  font-size: 25px;
}
.edit-input {
  background: rgba(255,255,255, 0.00) !important;
  width: 100%;
  text-align: center;
  color: white;
  font-weight: bold;
  border: none;
}
.box-table {
  width:   100%;
  padding: 8px;
  border: solid thin #ccc;
  margin-bottom: 8px;
}
.header{
  padding: 8px;
}
.body {
  height: 400px;
  padding: 8px;
  margin-bottom: 16px; 
}
.editor {
  text-align: left;
  border: none;
  height: 50px;
  margin-bottom: 24px;
  background: white;
}
.title-group {
  width: 100%;
  padding: 5px 10px;
  text-align: left;
  font-size: x-large;
  font-weight: bold;
  position: relative;
  &.-input {
    background-color: transparent !important;
    border: dashed thin #eee;
    width: 80%;
  }
}
.color-list {
  width: 180px;
  height: 250px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
  position: absolute;
  z-index: 2;
  background: white;
  padding: 8px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  right: 0;
  top: 50px;
}
.color-p {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin: 4px;
  cursor: pointer;
}
.content-group {
  width: 100%;
  padding: 5px 10px;
  text-align: left;
  font-size: x-large;
  font-weight: bold;
  border-left: solid 8px;
}
.content-group-detail {
  width: 100%;
  padding: 5px 10px;
  text-align: left;
  font-size: 16px;
  font-weight: bold;
  border: solid thin #ccc;
  border-bottom: none;
}

.upload-form {
  position: relative;
}
.upload-style {
  width: 200px;
  border-radius: 10px;
}
.upload-style > input {
  display: none;
}

.parent-box {
  display: flex;
  justify-content: space-around;
  padding: 40px;
}
.box-request {
  width: 100%;
  height: auto;
  padding: 20px;
  font-size: 15px;
  text-align: left;
}
.horizontal-image {
  -webkit-overflow-scrolling: touch;
  white-space: nowrap;
  height: 300px;
  width: -webkit-fill-available;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.horizontal-image li {
  background: #fff;
  margin: 2px;
  text-align: center;
  width: 230px;
}
.image-list {
  width: 230px;
  height: 180px;
  object-fit: cover;
  border-radius: 10px;
  cursor: pointer;
}
.background-img-button {
  background: rgba(255,255,255, 0.00) !important;
  border: dashed thin #eee;
  font-size: 13px;
  width: 120px;
  padding: 10px;
  border-radius: 10px;
  color: white;
  position: absolute;
  bottom: 10px;
  right: 10px;
}
.del-btn-wrapper {
  text-align: right;
}
.del-btn {
  color: red;
  margin-top: 4px;
  margin-right: 8px;
}

// 吹き出し
.tooltip{
    position: relative;
    cursor: pointer;
    display: inline-block;
}
.tooltip p{
    margin:0;
    padding:0;
}
.description {
    display: none;
    position: absolute;
    padding: 10px;
    font-size: 12px;
    line-height: 1.6em;
    color: #fff;
    border-radius: 5px;
    background: #000;
    width: 118px;
    left: 60px;
    white-space: pre-wrap;
}
.description:before {
    content: "";
    position: absolute;
    top: 0px;
    left: 130px;
    border: 15px solid transparent;
    border-top: 15px solid #000;
    margin-left: -15px;
    transform: rotateZ(270deg);
}
.tooltip:hover .description{
    display: inline-block;
    top: 0px;
    left: -130px;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/EmploymentPage/MainCustom.vue